import { motion } from 'framer-motion';

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

/**
 * Grille masonry (colonnes en cascade) pour des médias de hauteurs variées.
 * `columns` : nombre de colonnes CSS (responsive géré par l'appelant).
 * `renderItem(item)` : rendu de chaque carte, doit inclure sa propre image/hauteur naturelle.
 */
export default function MasonryGallery({ items, columns = 3, gap = 16, renderItem }) {
  if (!items || items.length === 0) return null;
  return (
    <div style={{ columnCount: columns, columnGap: gap, width: '100%' }}>
      {items.map((item, i) => (
        <motion.div
          key={item.id ?? i}
          style={{ breakInside: 'avoid', marginBottom: gap }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {renderItem(item)}
        </motion.div>
      ))}
    </div>
  );
}
